import { render, staticRenderFns } from "./resourceDatabaseManagementEdit.vue?vue&type=template&id=328d3f25&scoped=true"
import script from "./resourceDatabaseManagementEdit.vue?vue&type=script&lang=js"
export * from "./resourceDatabaseManagementEdit.vue?vue&type=script&lang=js"
import style0 from "./resourceDatabaseManagementEdit.vue?vue&type=style&index=0&id=328d3f25&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d3f25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328d3f25')) {
      api.createRecord('328d3f25', component.options)
    } else {
      api.reload('328d3f25', component.options)
    }
    module.hot.accept("./resourceDatabaseManagementEdit.vue?vue&type=template&id=328d3f25&scoped=true", function () {
      api.rerender('328d3f25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/resourceManagement/resourceDatabaseManagementEdit.vue"
export default component.exports